import { Component, AfterViewInit } from '@angular/core';
import { MapBounds } from '../models/map.bounds';
import { MapLatLng } from '../models/map.latlng';
import { MapBaseDirective } from '../base/map.base';
import { MapMarker } from '../models/map.marker';
import { HMapMarker } from './hmap.marker';
import { MapCluster } from '../models/map.cluster';
import { HMapCluster } from './hmap.cluster';

// Api de Here
// <link rel="stylesheet" type="text/css" href="https://js.api.here.com/v3/3.1/mapsjs-ui.css" />
// <script type="text/javascript" src="https://js.api.here.com/v3/3.1/mapsjs-core.js"></script>
// <script type="text/javascript" src="https://js.api.here.com/v3/3.1/mapsjs-service.js"></script>
// <script type="text/javascript" src="https://js.api.here.com/v3/3.1/mapsjs-ui.js"></script>
// <script type="text/javascript" src="https://js.api.here.com/v3/3.1/mapsjs-mapevents.js"></script>
// <script type="text/javascript" src="https://js.api.here.com/v3/3.1/mapsjs-clustering.js"></script>
// <script type="text/javascript" src="https://js.api.here.com/v3/3.1/mapsjs-data.js"></script>
// <script type="text/javascript" src="https://js.api.here.com/v3/3.1/mapsjs-harp.js"></script>

import { MapPolyline } from '../models/map.polyline';
import { MapPolylinePoint } from '../models/map.polylinePoint';
import { HPolyline } from './hmap.polyline';
import { MapCircle } from '../models/map.circle';
import { HCircle } from './hmap.circle';
import { MapPolygon } from '../models/map.polygon';
import { HPolygon } from './hmap.polygon';
import { MapPolygonPoint } from '../models/map.polygonPoint';
import { MapService } from '../map.service';
import { HeatMap } from '../models/map.heatMap';
import { HMapHeatMap } from './hmap.heatMap';
import { MapPoint } from '../models/map.point';
import { HMapItinerary } from './hmap.itinerary';
import { HttpClient } from '@angular/common/http';
import { MapPlace } from '../models/map.place';

declare var H: any;

@Component({
  selector: 'lib-hmap-movisat',
  templateUrl: './hmap.component.html',
  styleUrls: ['./hmap.component.css']
})
export class HMapComponent extends MapBaseDirective implements AfterViewInit {
  private platform: any;
  private mapBehavior: any;
  private defaultLayers: any;
  private ui: any;
  public markerGroup: any;
  public infoWindowMarker: any;
  private infoWindowPolyline: any;
  private infoWindowCircle: any;
  public infoWindowSearch: any;
  private oldZoom = 0;
  public selectedMarker = 0;
  public selectedToolTipMarker = 0;
  public static mapCount = 0;
  public mapId = 0;
  public defaultCursor = '';
  public tooltipMarker: any;
  public timerTooltip?: any;
  private myPosMarker: any = null;
  private maxZoom = 22;
  // Hash con los círculos añadidos
  public circleList = new Map<number, HCircle>();

  // Para búsquedas sobre la cartografía
  public geoSearch = '';
  private searchTimer: any;
  private searchPoints = new Map<string, any>();

  public constructor(public mapService: MapService, public http: HttpClient) {
    super();
    this.mapId = HMapComponent.mapCount;
    if (HMapComponent.mapCount < 9) {
      HMapComponent.mapCount++
    } else {
      HMapComponent.mapCount = 0;
    }
  }

  ngAfterViewInit() {
    // Vector->normal->map,traffic,trafficincidents,truk
    // Raster->normal->base,basenight,map,mapnight,labels,trafficincidents,transit,xbase,xbasenight
    // raster->satellite->base,labels,map,xbase
    // raster->terrain->base,labels,map,xbase

    // Creo el mapa
    this.platform = new H.service.Platform({
      apikey: this.mapService.config?.hereApiKey
    });
    const pixelRatio = window.devicePixelRatio || 1;
    this.defaultLayers = this.platform.createDefaultLayers({
      engineType: H.map.render.RenderEngine.EngineType.HARP,
      tileSize: pixelRatio === 1 ? 256 : 512,
      ppi: pixelRatio === 1 ? undefined : 320,
      lg: this.cartoType !== 'raster' ? this.lang.substring(0, 2)
        : this.getLangRaster(this.lang.substring(0, 2))
    });

    // Estos son los estilos que se pueden poner en el mapa
    // explore.day
    // lite.day
    // logistics.day
    // topo.day
    // logistics.night
    // explore.night
    // lite.night
    // topo.night
    // explore.satellite.day
    // lite.satellite.day
    // satellite.day
    // logistics.satellite.day
    let rasterProvider = null;
    if (this.cartoType === 'raster') {
      rasterProvider = new H.service.rasterTile.Provider(
        this.platform.getRasterTileService({
          queryParams: {
            style: "explore.day",
            size: 512,
          },
        })
      );
    }
    this.map = new H.Map(
      document.getElementById('mapContainer' + this.mapId),
      this.cartoType === 'raster' ? new H.map.layer.TileLayer(rasterProvider) :
        this.defaultLayers.vector.normal.map,
      {
        zoom: this.zoom,
        center: this.center,
        pixelRatio: pixelRatio,
        engineType: this.cartoType === 'raster' ? H.map.render.RenderEngine.EngineType.P2P :
          H.map.render.RenderEngine.EngineType.HARP
      }
    );

    this.maxZoom = this.cartoType === 'raster' ? 18 : 22;
    // Posiciono los controles del mapa
    this.setMapControls();
    // Activo la captura de eventos del mapa
    this.mapBehavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
    // Desactivo el zoom fraccional si no es raster
    if (this.cartoType !== 'raster') {
      this.mapBehavior.disable(H.mapevents.Behavior.Feature.FRACTIONAL_ZOOM);
    }
    // Establezco los eventos necesarios para controlar el mapa
    this.setMapEvents();
    // Creo el geocoder
    this.geoCoder = this.platform.getSearchService();
    this.setMapResize();
    this.setOnMapClick();
    this.setOnMapMouseMove();
    this.setOnChangeBounds();
    this.setOnChangeZoom();
    this.setMarkerGroup();
    this.createPolylineInfowindow();
    this.createCircleInfowindow();
    this.onMapReady(this);
    // Cunfiguro es estilo de la cartografía, si no es raster
    if (this.cartoType !== 'raster') {
      const style = this.map.getBaseLayer().getProvider().getStyle();
      const changeStyle = (style: any) => {
        const features: any[] = style.getEnabledFeatures();
        if (features) {
          for (let i = 0; i < features.length; i++) {
            // Oculto los edificios en 3D
            if (features[i].feature === 'building extruded') {
              features.splice(i, 1);
              break;
            }
          }
          style.setEnabledFeatures(features);
        }
      }
      const handler = (evt: any) => {
        const style = evt.target;
        if (style.getState() === H.map.render.Style.State.READY) {
          style.removeEventListener('change', handler);
          changeStyle(style);
        }
      };
      if (style.getState() === H.map.render.Style.State.READY) {
        changeStyle(style);
      } else {
        style.addEventListener('change', handler);
      }
    }
    // Creo el tooltip para los marcadores
    this.tooltipMarker = document.createElement('div');
    this.tooltipMarker.id = 'here_tooltip';
    this.tooltipMarker.style.position = 'absolute';
    this.tooltipMarker.style.fontSize = '13px';
    this.tooltipMarker.style.fontFamily = 'Helvetica';
    this.map.getElement().appendChild(this.tooltipMarker);
  }

  // Establezco la posición de los controles
  setMapControls() {
    // Posiciono los controles
    this.ui = H.ui.UI.createDefault(this.map, this.defaultLayers, this.lang);
    this.ui.getControl('mapsettings').setAlignment('right-top');
    this.ui.getControl('zoom').setAlignment('right-top');
    this.ui.getControl('scalebar').setAlignment('right-bottom');
    this.ui.addControl('zoomRectangle', new H.ui.ZoomRectangle());
    this.ui.getControl('zoomRectangle').setAlignment('right-top');
    // Esto lo hago para poder cambiar el texto que aparece cuando pasa el cursor sobre el botón
    // porque Here no lo traduce
    this.ui.getControl('zoomRectangle').getElement().addEventListener('mouseover', (event: any) => {
      event.target.title = this.translate('Zoom_encuadre', 'Zoom rectangular')
    });
  }

  // Devuelve el nivel máximo de zoom
  override getMaxZoom() {
    return this.maxZoom;
  }

  onMyLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = new MapLatLng(position.coords.latitude, position.coords.longitude);
        this.map.setCenter(pos);
        if (this.zoom < 16) {
          this.setZoom(16);
        }
        if (this.myPosMarker) {
          this.map.removeObject(this.myPosMarker);
        }
        this.myPosMarker = new H.map.Marker(pos, {
          icon: new H.map.Icon('assets/images/pos.png', {
            size: new H.math.Size(32, 32),
            anchor: new H.math.Point(16, 16)
          }),
          min: 0,
          max: 22,
          volatility: true,
          visible: true,
          zIndex: 999
        });
        this.map.addObject(this.myPosMarker);
        // Creo el texto que sale al pasar el puntero por encima
        this.myPosMarker.addEventListener('pointerenter', (event: any) => {
          const pointer = this.map.geoToScreen(event.target.getGeometry());
          const left = pointer.x - (this.tooltipMarker.offsetWidth / 2);
          const top = pointer.y - 10;
          this.tooltipMarker.style.backgroundColor = 'white';
          this.tooltipMarker.style.border = 'black 0.1px solid';
          this.tooltipMarker.style.left = left + 'px';
          this.tooltipMarker.style.top = top + 'px';
          this.tooltipMarker.innerHTML = '&nbsp;' + event.target.getGeometry().lat + ', ' +
            event.target.getGeometry().lng + '&nbsp;';
          this.timerTooltip = setTimeout(() => {
            clearTimeout(this.timerTooltip);
            this.timerTooltip = undefined;
            this.tooltipMarker.style.display = 'block';
          }, 500);
        }, false);
        this.myPosMarker.addEventListener('pointerleave', (event: any) => {
          if (this.timerTooltip) {
            clearTimeout(this.timerTooltip);
            this.timerTooltip = undefined;
          }
          this.tooltipMarker.style.display = 'none';
        }, false);
      });
    }
  }

  // Establece el @Output cuando se pincha sobre el mapa
  setOnMapClick() {
    this.map.addEventListener('tap', (event: any) => {
      const coord = this.map.screenToGeo(event.currentPointer.viewportX,
        event.currentPointer.viewportY);
      this.onMapClick(new MapLatLng(coord.lat, coord.lng));
    });
  }

  // Establece el @Output cuando se mueve el cursor sobre el mapa
  setOnMapMouseMove() {
    this.map.addEventListener('pointermove', (event: any) => {
      if (this.timerTooltip) {
        clearTimeout(this.timerTooltip);
        this.timerTooltip = setTimeout(() => {
          clearTimeout(this.timerTooltip);
          this.timerTooltip = undefined;
          this.tooltipMarker.style.display = 'block';
        }, 500);
      }
      const coord = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
      this.onMapMouseMove(new MapLatLng(coord.lat, coord.lng));
    });
  }

  setMapEvents(): void {
    // Eventos necesarios para poder controlar el arrastre de objetos
    this.map.addEventListener('dragstart', (event: any) => {
      const target = event.target;
      const pointer = event.currentPointer;
      if (event.target instanceof H.map.Marker) {
        this.infoWindowMarker.close();
        this.tooltipMarker.style.display = 'none';
        const targetPosition = this.map.geoToScreen(target.getGeometry());
        target['offset'] = new H.math.Point(pointer.viewportX - targetPosition.x,
          pointer.viewportY - targetPosition.y);
        this.mapBehavior.disable();
      }
    }, false);
    // Evento para saber cuando se arrastran objetos
    this.map.addEventListener('drag', (event: any) => {
      const target = event.target;
      const pointer = event.currentPointer;
      if (event.target instanceof H.map.Marker) {
        target.setGeometry(this.map.screenToGeo(pointer.viewportX - target['offset'].x,
          pointer.viewportY - target['offset'].y));
        const textMarker = target.getData().textMarker;
        if (textMarker) {
          textMarker.setGeometry(this.map.screenToGeo(pointer.viewportX - target['offset'].x,
            pointer.viewportY - target['offset'].y));
        }
        const marker = target.getData().marker?.marker;
        if (marker) {
          marker.setGeometry(this.map.screenToGeo(pointer.viewportX - target['offset'].x,
            pointer.viewportY - target['offset'].y));
          this.onMarkerMove({
            id: target.getData().id,
            position: target.getGeometry()
          });
        }
      }
    }, false);
    // Evento para saber cuando se dejan de arrastrar objetos
    this.map.addEventListener('dragend', (event: any) => {
      const target = event.target;
      if (target instanceof H.map.Marker) {
        this.mapBehavior.enable();
        const marker = target.getData().marker;
        if (marker) {
          const p = target.getGeometry();
          marker.position = new MapLatLng(target.getGeometry().lat, target.getGeometry().lng);
          const textMarker = target.getData().textMarker;
          if (textMarker) {
            textMarker.setGeometry(target.getGeometry());
          }
          if (marker.clusterV2) {
            marker.clusterV2.refreshMarker(marker);
          }
        }
        this.onMarkerDragEnd({
          id: target.getData().id,
          position: target.getGeometry()
        });
      }
    }, false);
  }

  // Establece el @Output cuando cambia el encuadre
  setOnChangeBounds() {
    // this.map.addEventListener('mapviewchangeend', (event: any) => {
    this.map.addEventListener('mapviewchange', (event: any) => {
      // Primero compruebo el nivel de zoom
      const zoom = Math.trunc(this.map.getZoom());
      this.onZoomChange(zoom);
      if (zoom !== this.oldZoom) {
        this.infoWindowMarker.close();
        this.tooltipMarker.style.display = 'none';
        this.infoWindowPolyline.close();
        this.infoWindowCircle.close();
      }
      this.oldZoom = zoom;
      // Ahora compruebo el encuadre
      let bounds = this.map.getViewModel().getLookAtData().bounds;
      bounds = bounds.getBoundingBox();
      const sw = new MapLatLng(bounds.getBottom(), bounds.getLeft());
      const ne = new MapLatLng(bounds.getTop(), bounds.getRight());
      this.onBoundsChange(new MapBounds(sw, ne));
    });
  }

  // Establece el @Output cuando cambia el nivel de zoom
  setOnChangeZoom() {
    // this.map.addEventListener('mapviewchangeend', (event: any) => {
    /*
    this.map.addEventListener('mapviewchange', (event: any) => {
      // const zoom = Math.trunc(this.map.getZoom() + 0.5);
      if (event.newValue && event.newValue.lookAt) {
        const zoom = event.newValue.lookAt.zoom;
        this.onZoomChange(zoom);
        if (zoom !== this.oldZoom) {
          this.infoWindowMarker.close();
          this.tooltipMarker.style.display = 'none';
          this.infoWindowPolyline.close();
          this.infoWindowCircle.close();
        }
        this.oldZoom = zoom;
      }
    });
    */
  }

  // Cuando se selecciona una ubicación de la lista
  onSelectSearch(event: any) {
    const item = this.searchPoints.get(event.target.value);
    if (item) {
      this.setCenter(item.position);
      if (!this.infoWindowSearch) {
        this.infoWindowSearch = new H.ui.InfoBubble({ lat: 0, lng: 0 });
        this.ui.addBubble(this.infoWindowSearch);
      }
      this.infoWindowSearch.setPosition(item.position);
      this.infoWindowSearch.setContent(event.target.value);
      this.infoWindowSearch.open();
      const geocodingParameters: any = {
        q: item.title,
        lang: this.lang,
        limit: 1,
        at: '' + item.position.lat + ',' + item.position.lng
      }
      this.geoCoder.geocode(geocodingParameters, (result: any) => {
        if (result.items && result.items.length > 0) {
          const place = new MapPlace();
          place.Label = result.items[0].title;
          place.Street = result.items[0].address.street;
          place.PostalCode = result.items[0].address.postalCode;
          place.Locality = result.items[0].address.city;
          place.AdministrativeArea2 = result.items[0].address.county;
          place.AdministrativeArea1 = result.items[0].address.state;
          place.Country = result.items[0].address.countryName;
          place.StreetNumber = result.items[0].address.houseNumber;
          this.onMapSearch(new MapLatLng(item.position.lat, item.position.lng), place);
        }
      });
    }
    this.geoSearch = '';
  }

  // Cada vez que se escribe una letra en el buscador
  onChangeSearch(event: any) {
    try {
      if (this.searchTimer !== null) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        let geocodingParameters: any = {
          q: this.geoSearch,
          lang: this.lang,
          limit: 5
        }
        const sb = this.searchBounds.split(',');
        if (sb.length === 4) {
          // Restrinjo el área de busqueda preferido
          const lat0 = Number.parseFloat(sb[0]) + (Number.parseFloat(sb[2]) - Number.parseFloat(sb[0])) / 2;
          const lng0 = Number.parseFloat(sb[1]) + (Number.parseFloat(sb[3]) - Number.parseFloat(sb[1])) / 2;
          const radius = this.distanceGeo(Number.parseFloat(sb[0]), Number.parseFloat(sb[1]), lat0, lng0);
          // in: 'countryCode:ESP,ITA,FRA', // Para limitar la búsqueda por paises
          // at: this.map.getCenter().lat + ',' + this.map.getCenter().lng, // Para especificar las coordenadas alrededor
          geocodingParameters.in = 'circle:' + lat0 + ',' + lng0 + ';r=' + Math.trunc(radius);
        } else {
          geocodingParameters.at = this.map.getCenter().lat + ',' + this.map.getCenter().lng;
        }
        const list: any = document.getElementById('hereMapSearch' + this.mapId);
        let options = '';
        if (this.geoSearch.length > 0) {
          // this.geoCoder.geocode(geocodingParameters, ((result: any) => {
          this.geoCoder.autosuggest(geocodingParameters, ((result: any) => {
            if (result) {
              let words: string[] = [];
              let words2: string[] = [];
              result.items.forEach((item: any) => {
                if (words.length < 1 && item.address && item.address.label) {
                  words = item.address.label.replace(/,/g, ' ').split(' ');
                  words2 = item.address.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/,/g, ' ').split(' ');
                }
              });
              this.geoSearch = this.geoSearch.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              this.searchPoints.clear();
              words.forEach((word: string, i: number) => {
                if (word.length > 0) {
                  this.geoSearch = this.geoSearch.replace(new RegExp(words2[i], 'gi'), words[i]);
                }
              });
              result.items.forEach((item: any) => {
                if (item.address && item.address.label && !this.searchPoints.get(item.address.label)) {
                  options += '<option value="' + item.address.label + '" /> ';
                  this.searchPoints.set(item.address.label, item);
                }
              });
              list.innerHTML = options;
            }
          }));
        }
      }, 250);
    }
    catch (e) {
      console.log(e);
    }
  }

  // Asegura que el mapa se redimensiona cuando cambia el tamaño de la ventana
  setMapResize() {
    window.addEventListener('resize', (event) => {
      this.resize();
    });
  }

  // Redimensiona el mapa para que se adapte al tamaño del div que lo contiene
  override resize() {
    this.map.getViewPort().resize();
  }

  // Falta ver como se cambia el tipo de mapa en Here
  override setMapType(type: string) {
    switch (type) {
      case 'satellite':
        // this.map.setType('satellite');
        break;
      case 'terrain':
        // this.map.setType('terrain');
        break;
      default:
        // this.map.setType('normal');
        break;
    }
  }

  // Crea el grupo para los marcadores
  setMarkerGroup() {
    if (this.markerGroup !== undefined) {
      this.map.removeObject(this.markerGroup);
    }
    this.markerGroup = new H.map.Group();
    this.map.addObject(this.markerGroup);
    // Creo un infowindow para cuando pasa el cursor sobre un
    // marcador y otro para cuando se pincha sobre él
    this.infoWindowMarker = new H.ui.InfoBubble({ lat: 0, lng: 0 });
    this.ui.addBubble(this.infoWindowMarker);
    // Comportamiento por defecto al pichar en un marcador del grupo de marcadores
    this.markerGroup.addEventListener('tap', (event: any) => {
      this.onMarkerClickEvent(event);
    }, false);
  }

  // Crea el infowindow para las polilineas
  createPolylineInfowindow() {
    this.infoWindowPolyline = new H.ui.InfoBubble({ lat: 0, lng: 0 });
    this.ui.addBubble(this.infoWindowPolyline);
  }

  // Crea el infowindow para los círculos
  createCircleInfowindow() {
    this.infoWindowCircle = new H.ui.InfoBubble({ lat: 0, lng: 0 });
    this.ui.addBubble(this.infoWindowCircle);
  }

  // Añade un marcador al mapa
  override addMarker(id: number, title: string, label: string, content: string, position: MapLatLng, icon: string,
    zIndex: number, drag: boolean, visible: boolean, minZoom: number, maxZoom: number,
    cluster: boolean, clusterV2: any): MapMarker {
    return new HMapMarker(id, title, label, content, position, icon, zIndex,
      this.map, drag, (visible && !cluster), minZoom, maxZoom, this, cluster || clusterV2);
  }

  // Cuando pasa el puntero por encima de un marcador
  onMarkerPointerEnter(event: any) {
    if (event.target.getData().title.length > 0) {
      const pointer = this.map.geoToScreen(event.target.getGeometry());
      const left = pointer.x - (this.tooltipMarker.offsetWidth / 2);
      const top = pointer.y - 10;
      this.tooltipMarker.style.backgroundColor = 'white';
      this.tooltipMarker.style.border = 'gray 0.1px solid';
      this.tooltipMarker.style.borderRadius = '2px';
      this.tooltipMarker.style.left = left + 'px';
      this.tooltipMarker.style.color = 'black';
      this.tooltipMarker.style.top = top + 'px';
      this.tooltipMarker.innerHTML = '&nbsp;' + event.target.getData().title + '&nbsp;';
      this.timerTooltip = setTimeout(() => {
        clearTimeout(this.timerTooltip);
        this.timerTooltip = undefined;
        this.tooltipMarker.style.display = 'block';
      }, 500);
    }
    document.body.style.cursor = 'pointer';
  }

  // Cuando deja de pasar el puntero por encima de un marcador
  onMarkerPointerLeave() {
    document.body.style.cursor = this.defaultCursor;
    if (this.timerTooltip) {
      clearTimeout(this.timerTooltip);
      this.timerTooltip = undefined;
    }
    this.tooltipMarker.style.display = 'none';
  }

  // Cuando se hace click sobre un marcador
  onMarkerClickEvent(event: any) {
    event.stopPropagation();
    const data = event.target.getData();
    if (data && data.title && data.title.length > 0) {
      const pointer = this.map.geoToScreen(event.target.getGeometry());
      const pos = this.map.screenToGeo(pointer.x, pointer.y - 16);
      this.infoWindowMarker.setPosition(pos);
      this.infoWindowMarker.setContent(event.target.getData().content);
      this.tooltipMarker.style.display = 'none';
      this.infoWindowMarker.open();
      this.selectedMarker = event.target.getData().id;
    }
    if (data && data.id) {
      this.onMarkerClick(data.id);
    }
  }

  // Elimina un marcador
  override removeMarker(marker: MapMarker) {
    try {
      if (marker instanceof HMapMarker) {
        marker.setVisible(false);
        if (marker.marker) {
          this.markerGroup.removeObject(marker.marker);
          if (marker.textMarker) {
            this.markerGroup.removeObject(marker.textMarker);
          }
          if (this.infoWindowMarker && this.selectedMarker === marker.id) {
            this.infoWindowMarker.close();
          }
        }
        // Si está en un cluster borro el marcador del cluster
        if (marker.clusterV2) {
          marker.clusterV2.removeMarker(marker, true);
        }
      }
    } catch {
    }
  }

  // Crea un cluster de marcadores
  override addCluster(id: number, maxZoom: number): MapCluster {
    const cluster = new HMapCluster(id, maxZoom, this, this.map);
    return cluster;
  }

  // Borra todos los marcadores del cluster
  override removeCluster(cluster: MapCluster) {
    cluster.removeMarkers();
  }

  // Devuelve las coordenadas de las esquinas del mapa
  override getBounds(): MapBounds {
    const b = this.map.getViewModel().getLookAtData();
    const bounds = b.bounds.getBoundingBox();
    const sw = new MapLatLng(bounds.getBottom(), bounds.getLeft());
    const ne = new MapLatLng(bounds.getTop(), bounds.getRight());
    return new MapBounds(sw, ne);
  }

  // Permite hacer un zoom de encuadre
  override fitTo(bounds: MapBounds) {
    var bbox = new H.geo.Rect(bounds.neCorner.lat, bounds.swCorner.lng, bounds.swCorner.lat, bounds.neCorner.lng);
    this.map.getViewModel().setLookAtData({
      bounds: bbox
    });
  }

  // Permite centrar el mapa en un punto con animación
  override panTo(point: MapLatLng) {
    this.map.setCenter(point, true);
  }

  // Crea una polilinea
  override addPolyline(id: number, color: string, weight: number, opacity: number, clickable: boolean): MapPolyline {
    const polyline = new HPolyline(id, this.map, color, opacity, weight, this);
    return polyline;
  }

  // Borra una polilinea
  override removePolyline(polyline: MapPolyline) {
    if (this.infoWindowPolyline) {
      this.infoWindowPolyline.close();
    }
    if (polyline instanceof MapPolyline) {
      polyline.remove();
    }
  }

  // Añade un punto a una polilinea
  override addPolylinePoint(id: number, polyline: MapPolyline, content: string, position: MapLatLng): MapPolylinePoint {
    const point = polyline.addPoint(id, content, position);
    point.polyline = polyline;
    if (polyline.polyline !== undefined && polyline.points.length === 2) {
      polyline.polyline.addEventListener('tap', (event: any) => {
        event.stopPropagation();
        const pos = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
        const selectPoint = polyline.getNearbyPoint(pos);
        if (selectPoint !== null) {
          if (selectPoint.content !== undefined && selectPoint.content.length > 0) {
            this.infoWindowPolyline.setContent(selectPoint.content);
            this.infoWindowPolyline.setPosition(selectPoint.point);
            this.infoWindowPolyline.open();
          }
          selectPoint.clickPoint = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
          this.onPolylineClick(selectPoint);
        }
      });
      polyline.polyline.addEventListener('pointerenter', (event: any) => {
        document.body.style.cursor = 'pointer';
      }, false);
      polyline.polyline.addEventListener('pointerleave', (event: any) => {
        document.body.style.cursor = this.defaultCursor;
      }, false);
    }
    return point;
  }

  // Crea un polígono
  override addPolygon(id: number, strokeColor: string, weight: number, strokeOpacity: number,
    fillColor: string, fillOpacity: number, editable: boolean, hole: boolean, content: string): MapPolygon {
    const polygon = new HPolygon(id, this.map, strokeColor, strokeOpacity, weight, fillColor, fillOpacity, editable,
      hole, this, content);
    return polygon;
  }

  // Borra un polígono
  override removePolygon(polygon: MapPolygon) {
    if (this.infoWindowPolyline) {
      this.infoWindowPolyline.close();
    }
    if (polygon instanceof MapPolygon) {
      polygon.remove();
    }
  }

  // Añade un punto a un polígono
  override addPolygonPoint(id: number, polygon: MapPolygon, content: string, position: MapLatLng, dataModel: any): MapPolygonPoint {
    const point = polygon.addPoint(id, content, position, dataModel);
    point.polygon = polygon;
    if (polygon.polygon !== undefined && polygon.points.length === 2) {
      polygon.polygon.addEventListener('tap', (event: any) => {
        event!.stopPropagation();
        const pos = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
        const selectPoint = polygon.getNearbyPoint(pos);
        if (selectPoint !== null) {
          if (selectPoint.content !== undefined && selectPoint.content.length > 0) {
            this.infoWindowPolyline.setContent(selectPoint.content);
            this.infoWindowPolyline.setPosition(selectPoint.point);
            this.infoWindowPolyline.open();
          }
          selectPoint.clickPoint = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
          this.onPolygonClick(selectPoint);
          this.onMapClick(new MapLatLng(pos.lat, pos.lng));
        }
      });
      polygon.polygon.addEventListener('pointerenter', (event: any) => {
        document.body.style.cursor = 'pointer';
      }, false);
      polygon.polygon.addEventListener('pointerleave', (event: any) => {
        document.body.style.cursor = this.defaultCursor;
      }, false);
    }
    return point;
  }

  // Crea un círculo
  override addCircle(id: number, content: string, strokeColor: string, strokeOpacity: number,
    strokeWeight: number, fillColor: string, fillOpacity: number, point: MapLatLng,
    radius: number, editable: boolean, draggable: boolean) {
    const circle = new HCircle(id, this.map, content, strokeColor, strokeOpacity,
      strokeWeight, fillColor, fillOpacity, point, radius, editable, draggable, this);
    this.circleList.set(id, circle);
    circle.circle.addEventListener('tap', (event: any) => {
      event.stopPropagation();
      if (event.target.getData().content.length > 0) {
        this.infoWindowCircle.setPosition(event.target.getCenter());
        this.infoWindowCircle.setContent(event.target.getData().content);
        this.infoWindowCircle.open();
      }
      const circle: any = this.circleList.get(id)
      if (circle) {
        circle.clickPoint = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
      }
      this.onCircleClick(circle);
      this.onMapClick(circle.center);
    });
    return circle;
  }

  // Borra un círculo
  override removeCircle(circle: MapCircle) {
    if (this.infoWindowCircle) {
      this.infoWindowCircle.close();
    }
    if (circle && circle instanceof MapCircle) {
      circle.remove();
    }
  }

  // Carga un archivo GeoJson
  override loadGeoJson(file: string, options: any): any {
    return this.addGeoJson(null, options, file);
  }

  hex2rgba(hex: any, alpha = 1) {
    const [r, g, b] = hex.match(/\w\w/g).map((x: any) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  }

  // Carga un archivo GeoJson
  override addGeoJson(geoJson: any, options: any, file: string): any {
    const _this = this;
    const reader = new H.data.geojson.Reader(file, {
      disableLegacyMode: true,
      style: function (mapObject: any) {
        if (mapObject instanceof H.map.Marker) {
          // Comportamiento por defecto al pasar el cursor por encima
          _this.onPointerEnterOrLeave(mapObject);
          mapObject.addEventListener('tap', (event: any) => {
            // Obtengo las coordenadas del marcador
            const marker = event.target.getGeometry();
            const res = new HMapMarker(0, '', '', '', new MapLatLng(marker.lat, marker.lng),
              '', 0, _this.map, false, false, 0, 22, _this, null);
            res.dataModel = options ? options.dataModel : undefined;
            if (options && options.content) {
              _this.infoWindowMarker.setContent(options.content);
              _this.infoWindowMarker.setPosition(res.position);
              _this.infoWindowMarker.open();
            }
            event.stopPropagation();
            _this.onMarkerClickGeoJson(res);
          });
          mapObject.setIcon(new H.map.Icon('assets/images/redmarker.png'));
        } else {
          if (mapObject instanceof H.map.Polyline) {
            // Comportamiento por defecto al pasar el cursor por encima
            _this.onPointerEnterOrLeave(mapObject);
            mapObject.addEventListener('tap', (event: any) => {
              // Obtengo los puntos de la polilínea
              const polyline = event.target.getGeometry();
              const pointsArray = polyline.getLatLngAltArray();
              // Calculo la posición donde se ha pinchado y obtengo el punto más cercano
              const point = _this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
              const index = _this.getNearbyPoint(point, pointsArray, 20);
              const res = new MapPolylinePoint(0, '', new MapLatLng(pointsArray[index], pointsArray[index + 1]));
              res.dataModel = options ? options.dataModel : undefined;
              if (options && options.content) {
                _this.infoWindowPolyline.setContent(options.content);
                _this.infoWindowPolyline.setPosition(res.point);
                _this.infoWindowPolyline.open();
              }
              event.stopPropagation();
              res.clickPoint = _this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
              _this.onPolylineClick(res);
            });
            const prop = mapObject.data.properties;
            mapObject.setStyle({
              lineWidth: options && options.strokeWeight ? options.strokeWeight : prop['stroke-width'] ? prop['stroke-width'] : 1,
              strokeColor: options && options.strokeColor ? _this.hex2rgba(options.strokeColor, options.strokeOpacity) :
                (_this.hex2rgba(prop['stroke'] ? prop['stroke'] : '#ff0000', prop['stroke-opacity'] ? prop['stroke-opacity'] : 1))
            });
          } else {
            if (mapObject instanceof H.map.Polygon) {
              mapObject.addEventListener('tap', (event: any) => {
                // Comportamiento por defecto al pasar el cursor por encima
                _this.onPointerEnterOrLeave(mapObject);
                // Obtengo los puntos del multipolígono
                const objects = event.target.getGeometry();
                const geometries = objects.getGeometries();
                const pointsArray: any = [];
                geometries.forEach((polygon: any) => {
                  const points = polygon.getExterior().getLatLngAltArray();
                  points.forEach((p: any) => {
                    pointsArray.push(p);
                  });
                });
                // Calculo la posición donde se ha pinchado y obtengo el punto más cercano
                const point = _this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
                const index = _this.getNearbyPoint(point, pointsArray, 20);
                const res = new MapPolygonPoint(0, '', new MapLatLng(pointsArray[index], pointsArray[index + 1]), null);
                res.dataModel = options ? options.dataModel : undefined;
                if (options && options.content) {
                  _this.infoWindowPolyline.setContent(options.content);
                  _this.infoWindowPolyline.setPosition(res.point);
                  _this.infoWindowPolyline.open();
                }
                event.stopPropagation();
                res.clickPoint = _this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
                _this.onPolygonClick(res);
              });
              const prop = mapObject.data.properties;
              mapObject.setStyle({
                lineWidth: options && options.strokeWeight ? options.strokeWeight : (prop['stroke-width'] ? prop['stroke-width'] : 1),
                strokeColor: options && options.strokeColor ? _this.hex2rgba(options.strokeColor, options.strokeOpacity) :
                  (_this.hex2rgba(prop['stroke'] ? prop['stroke'] : '#ff0000', prop['stroke-opacity'] ? prop['stroke-opacity'] : 1)),
                fillColor: options && options.fillColor ? _this.hex2rgba(options.fillColor, options.fillOpacity) :
                  (_this.hex2rgba(prop['fill'] ? prop['fill'] : '#ff0000', prop['fill-opacity'] ? prop['fill-opacity'] : 0.5))
              });
            } else { // Multipolygons
              const objs = mapObject.getObjects();
              objs.forEach((obj: any) => {
                // Comportamiento por defecto al pasar el cursor por encima
                _this.onPointerEnterOrLeave(obj);
                obj.addEventListener('tap', (event: any) => {
                  // Obtengo los puntos del multipolígono
                  const polygon = event.target.getGeometry();
                  const points = polygon.getExterior();
                  const pointsArray = points.getLatLngAltArray();
                  // Calculo la posición donde se ha pinchado y obtengo el punto más cercano
                  const point = _this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
                  const index = _this.getNearbyPoint(point, pointsArray, 20);
                  const res = new MapPolygonPoint(0, '', new MapLatLng(pointsArray[index], pointsArray[index + 1]), null);
                  res.dataModel = options ? options.dataModel : undefined;
                  if (options && options.content) {
                    _this.infoWindowPolyline.setContent(options.content);
                    _this.infoWindowPolyline.setPosition(res.point);
                    _this.infoWindowPolyline.open();
                  }
                  event.stopPropagation();
                  res.clickPoint = _this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
                  _this.onPolygonClick(res);
                });
                const prop = obj.getStyle();
                obj.setStyle({
                  lineWidth: options && options.strokeWeight ? options.strokeWeight : (prop.lineWidth ? prop.lineWidth : 1),
                  strokeColor: options && options.strokeColor ? _this.hex2rgba(options.strokeColor, options.strokeOpacity) :
                    (prop.strokeColor ? prop.strokeColor : _this.hex2rgba('#ff0000', 0.3)),
                  fillColor: options && options.fillColor ? _this.hex2rgba(options.fillColor, options.fillOpacity) :
                    (prop.fillColor ? prop.fillColor : _this.hex2rgba('#ff0000', 0.3))
                });
              });
            }
          }
        }
      }
    });
    if (file) {
      reader.parse(file);
    } else {
      reader.parseData(geoJson);
    }
    const layer = reader.getLayer();
    this.map.addLayer(layer);
    if (geoJson) {
      // Calculo el centroide
      let latSW = 90;
      let lngSW = 180;
      let latNE = -90;
      let lngNE = -180;
      for (let i = 0; i < geoJson.geometry.coordinates[0].length; i++) {
        for (let j = 0; j < geoJson.geometry.coordinates[0][i].length; j++) {
          for (let k = 0; k < geoJson.geometry.coordinates[0][i].length; k++) {
            const pos = geoJson.geometry.coordinates[0][i][k];
            latSW = Math.min(latSW, pos[1]);
            lngSW = Math.min(lngSW, pos[0]);
            latNE = Math.max(latNE, pos[1]);
            lngNE = Math.max(lngNE, pos[0]);
          }
        }
        if (options && options.label) {
          // Pongo el texto en el centro
          const width = options.label.length * 10; // Porque la fuente es de 10pt
          const iconText = '<svg width="' + width + '" height="32" xmlns="http://www.w3.org/2000/svg">' +
            '<text x="' + width / 2 + '" y="24" font-size="12pt" font-family="Arial" text-anchor="middle" fill="' +
            options.textColor + '">' +
            options.label + '</text></svg>';
          layer.markerText = new H.map.Marker(new MapLatLng(latSW + (latNE - latSW) / 2.0, lngSW + (lngNE - lngSW) / 2.0), {
            icon: new H.map.Icon(iconText, {
              size: new H.math.Size(width, 32),
              anchor: new H.math.Point(width / 2, 19)
            }),
            min: 1,
            max: 99,
            volatility: true,
            visible: true,
            zIndex: 99
          });
          this.map.addObject(layer.markerText);
        }
      }
    }
    return layer;
  }

  onPointerEnterOrLeave(obj: any) {
    // Comportamiento por defecto al pasar el cursor sobre un objeto
    obj.addEventListener('pointerenter', (event: any) => {
      document.body.style.cursor = 'pointer'
    }, false);
    obj.addEventListener('pointerleave', (event: any) => {
      document.body.style.cursor = this.defaultCursor;
    }, false);
  }

  // Borra un GeoJson cargado anteriormente
  override removeGeoJson(obj: any): void {
    if (obj.markerText) {
      this.map.removeObject(obj.markerText);
    }
    this.map.removeLayer(obj);
  }

  // Añade un mapa de calor
  override addHeatMap(id: number, points: MapLatLng[], markers: MapMarker[], radius: number, dissipating: boolean,
    maxIntensity: number, opacity: number, gradient: any[]): any {
    return new HMapHeatMap(id, this.map, points, markers, opacity, maxIntensity);
  }

  // Elimina un mapa de calor
  override removeHeatMap(heatMap: HeatMap) {
    heatMap.heatMap.clear();
  }

  // Pasa una coordenada geográfica a un punto
  override fromLatlngToPoint(position: MapLatLng): MapPoint {
    const point = this.map.geoToScreen(position);
    return new MapPoint(point.x, point.y);
  }

  // Pasa un punto a coordenada geográfica
  override fromPointToLatlng(point: MapPoint): MapLatLng {
    const pos = this.map.screenToGeo(point.x, point.y);
    return new MapLatLng(pos.lat, pos.lng);
  }

  // Pasa una coordenada geográfica a un punto de pantalla
  override latLngToScreenPoint(position: MapLatLng): MapPoint {
    const point = this.map.geoToScreen(position);
    return new MapPoint(point.x, point.y);
  }

  // Pasa un punto de pantalla a coordenada geográfica
  override screenPointToLatLng(point: MapPoint): MapLatLng {
    const pos = this.map.screenToGeo(point.x, point.y);
    return new MapLatLng(pos.lat, pos.lng);
  }

  // Permite cambiar el puntero del ratón sobre el mapa
  override setMousePointer(pointer: string) {
    document.body.style.cursor = pointer && pointer.length > 0 ? "url('" + pointer + "'), auto" : '';
    this.defaultCursor = document.body.style.cursor;
  }

  // Oculta el infowindow de los marcadores
  override closeInfowindowMarker(): void {
    if (this.infoWindowMarker) {
      this.infoWindowMarker.close();
    }
  }

  override itinerary(fromId: string, toId: string, fromPos: MapLatLng, toPos: MapLatLng, resultId: string): HMapItinerary {
    return new HMapItinerary(this.map, fromId, toId, fromPos, toPos, resultId, this);
  }

  // Devuelve el punto del polígono más cercano a un punto dado
  public getNearbyPoint(position: any, points: number[], radio: number): number {
    let i = 0, index = 0;
    let oldDist = 99999999;
    let lastPoint: MapLatLng | undefined;
    for (i = 0; i < points.length; i += 3) {
      if (lastPoint) {
        const dist = this.distancePointToSegment(lastPoint.lng, lastPoint.lat, points[i + 1],
          points[i], position.lng, position.lat);
        if (dist <= radio && dist < oldDist) {
          index = i;
          oldDist = dist;
        }
      }
      lastPoint = new MapLatLng(points[i], points[i + 1]);
    }
    if (index > 0) {
      if (this.dist(position.lng, position.lat, points[index + 1], points[index]) >
        this.dist(position.lng, position.lat, points[index - 2], points[index - 3])) {
        index = index - 3;
      }
    }
    return index;
  }

  // https://developer.here.com/documentation/map-tile/dev_guide/topics/resource-base-maptile.html
  getLangRaster(lang: string): string {
    switch (lang) {
      case 'es':
        return 'spa';
      case 'eu':
        return 'baq';
      case 'ca':
        return 'cat';
      case 'de':
        return 'ger';
      case 'en':
        return 'eng';
      case 'fr':
        return 'fre';
      case 'it':
        return 'ita';
      case 'pt':
        return 'por';
      default:
        return 'mul'; // Cada pais en su idioma
    }
    return lang;
  }
}

/*
ara – árabe
baq – euskera
cat – catalán
chi – chino (simplificado)
cht – chino (tradicional)
cze – checo
dan – danés
dut – holandés
eng – inglés
fin - finlandés
fre – francés
ger – alemán
gle – gaélico
gre – griego
heb – hebreo
hin - hindi
ind – indonesio
ita – italiano
mul – Múltiples idiomas
nor – noruego
por – persa
pol – polaco
por – portugués
rus – ruso
sin – cingalés
spa – español
swe – sueco
tha - tailandés
tur – Turco
ukr – ucraniano
urd - urdu
vie – vietnamita
wel – galés
*/